module.exports = __webpack_public_path__ + "images/application/templates/layout-plain-fcc367b0.png";